// 风控业务方 ID：https://km.sankuai.com/page/140329051
export const RISKCONTROL_PARTNER_ID = 12;

// 验证中心验证识别码：https://km.sankuai.com/page/110297073
export const enum verifyNo {
  wallet = 1,
  cashier = 2
}

// 支付 scene
export const enum PaymentScene {
  PaymentSceneWalletPassword = 101, // 钱包－支付密码
  PaymentSceneWalletCharge = 102, // 钱包－充值
  PaymentSceneWalletBindOrUnbindBankCard = 104, // 钱包-绑定或解绑银行卡
  PaymentSceneWalletFingerprintPay = 105, // 钱包-指纹支付
  PaymentSceneWalletNoPasswordPay = 106, // 钱包-小额免密支付
  PaymentSceneWalletUserCertify = 107, // 钱包-用户实名认证
  PaymentSceneBarcodeBindBankCard = 108, // 付款码-绑定银行卡
  PaymentSceneConchGestureResetPayPassword = 110, // 海螺钱包手势密码-忘记支付密码
  PaymentSceneWalletFindPayPassword = 111, // 钱包-设置页找回支付密码
  PaymentSceneCashierVerifyPayPassword = 203, // 收银台－验证支付密码
  PaymentSceneMeituanPayVerifyPayPassword = 303, // 银行直连－验证支付密码
  PaymentSceneMeituanPaySetPassword = 305 // 美团支付-重置支付密码
}

// 支付密码错误类型：https://km.sankuai.com/page/15551509、https://km.sankuai.com/page/21645917
export const enum PayPasswordErrorType {
  MPM_PAY_PASSWORD_COMPLETELY_REPEATED = 'MPM_PAY_PASSWORD_COMPLETELY_REPEATED', // 请不要设置完全重复的数字
  MPM_PAY_PASSWORD_COMPLETELY_CONTINUOUS = 'MPM_PAY_PASSWORD_COMPLETELY_CONTINUOUS', // 请不要设置完全连续的数字
  MPM_PAY_PASSWORD_HAS_SET = 'MPM_PAY_PASSWORD_HAS_SET', // 支付密码已经存在
  MPM_PAY_PASSWORD_NOT_SET = 'MPM_PAY_PASSWORD_NOT_SET', // 支付密码不存在
  MPM_PAY_PASSWORD_RISK_EVENT_NOT_PASS = 'MPM_PAY_PASSWORD_RISK_EVENT_NOT_PASS', // 非法请求，请重新验证
  MPM_PAY_PASSWORD_FIND_NOT_PASS = 'MPM_PAY_PASSWORD_FIND_NOT_PASS', // 系统繁忙，请稍后再试
  MPM_PAY_PASSWORD_FORMAT_INVALID = 'MPM_PAY_PASSWORD_FORMAT_INVALID', // 支付密码只能为六位数字，请重新设置
  MPM_PAY_PASSWORD_SET_INVALID = 'MPM_PAY_PASSWORD_SET_INVALID', // 短信验证码超时，请重新获取短信验证码
  MPM_PAY_PASSWORD_INCORRECT = 'MPM_PAY_PASSWORD_INCORRECT', // 支付密码错误，请重新输入
  MPM_PAY_PASSWORD_CANNOT_BE_SAME = 'MPM_PAY_PASSWORD_CANNOT_BE_SAME', // 新密码与当前密码相同，请重新设置
  MPM_PAY_PASSWORD_FIND_INVALID = 'MPM_PAY_PASSWORD_FIND_INVALID', // 支付密码重置失败，超时或已经失效
  MPM_PAY_PASSWORD_VERIFY_OUT_LIMIT = 'MPM_PAY_PASSWORD_VERIFY_OUT_LIMIT', // 支付密码错误次数过多，请三小时后再试
  MPM_PAY_PASSWORD_NOT_BE_SAME = 'MPM_PAY_PASSWORD_NOT_BE_SAME', // 支付密码输入不一致，请重新设置
  MPM_PAY_PASSWORD_EQUAL_LOGIN_PASSWORD = 'MPM_PAY_PASSWORD_EQUAL_LOGIN_PASSWORD' // 支付密码和登陆密码一致，请重新设置
}

export enum RaptorPoint {
  TTIPosition = 20
}

// 国密
export enum CfcaCertRequestCodeType {
  GetCertificateStatus = 'getCertificateStatus', // 获取证书状态
  DownloadCertificate = 'downloadCertificate' // 下载证书
}

export enum CertificateStatusType {
  Activated = '0', // 已启用
  CertifyDisable = '1', // 已实名未启用
  Uncertify = '2' // 未实名
}

export enum EntryType {
  PaySetting = 'paySetting', // 钱包设置页入口
  Cashier = 'cashier' // 收银台入口
}

export const HornKey = 'pay-settings-config';

export const PayOrigin = {
  test: 'https://stable.pay.test.sankuai.com',
  staging: 'https://stable.pay.st.sankuai.com',
  prod: 'https://npay.meituan.com'
};

enum ShengxinProduct {
  OneClickPay = '极速支付',
  MtScorePay = '先用后付',
  DeductEntry = '自动扣款',
  FamilyCard = '亲情卡'
}

export const ShengxinProductsNameMap: Record<ShengxinProduct, string> = {
  [ShengxinProduct.OneClickPay]: 'oneClickPay',
  [ShengxinProduct.MtScorePay]: 'mtScorePay',
  [ShengxinProduct.DeductEntry]: 'deductEntry',
  [ShengxinProduct.FamilyCard]: 'familyCard'
};
